import React, { useEffect, useState, useContext, useCallback } from 'react'
import { Context } from '../../../context/app-context'
import GenericModal from '../../templates/generic-modal/generic-modal'
import ModalLogin from '../../molecules/modalLogin/modalLogin'
import ModalReedem from '../../molecules/modalRedeem/modalRedeem'
import ModalTerms from '../../molecules/modalTerms/modalTerms'
import ModalPregame from '../../molecules/modalPregame/modalPregame'
import ModalPubertad from '../../molecules/modalPubertad/modalPubertad'
import ModalUtero from '../../molecules/modalUtero/modalUtero'
import ModalFlujo from '../../molecules/modalFlujo/modalFlujo'
import ModalEndGame from '../../molecules/modalEndGame/modalEndGame'
import ModalUpdateData from '../../molecules/modalUpdateData/modalUpdateData'

// import ModalOTP from "../../molecules/modal-OTP/modal-OTP"
// import ModalConfirmation from "../../molecules/modal-confirmation/modal-confirmation"

export default function ModalViewer() {
  const [isDisabledScroll, setIsDisabledScroll] = useState(false)

  // const INITIAL_MODAL_STATE = <ModalGameUtero />
  const INITIAL_MODAL_STATE = null
  const [modal, setModal] = useState(INITIAL_MODAL_STATE)
  const { dispatch, modalActive } = useContext(Context)

  // ###########  GENERIC PARAMETERS
  const noClose = modalActive?.props?.noClose
  const colorBlur = modalActive?.props?.colorBlur
  // ###########  GENERIC PARAMETERS

  const handleClose = () => {
    setModal(null)
    dispatch({
      type: 'set-context',
      payload: {
        modalActive: null,
      },
    })
    if (modalActive?.handleClose) modalActive.handleClose()
  }

  useEffect(() => {
    setIsDisabledScroll(() => !!modal)
    return () => {
      setIsDisabledScroll(() => false)
    }
  }, [modal])

  useEffect(() => {
    document.body.style.overflow = isDisabledScroll ? 'hidden' : 'initial'
  }, [isDisabledScroll])

  useEffect(() => {
    if (modalActive && typeof modalActive.type === 'string') {
      const modalProps = { ...modalActive?.props }

      // MODALS COMPONENTS REGISTER
      const modalsList = {
        login: <ModalLogin {...modalProps} />,
        redemption: <ModalReedem {...modalProps} />,
        modalTerms: <ModalTerms {...modalProps} />,
        pregame: <ModalPregame {...modalProps} />,
        pubertadInstructions: <ModalPubertad {...modalProps} />,
        uteroInstructions: <ModalUtero {...modalProps} />,
        flujoInstructions: <ModalFlujo {...modalProps} />,
        endgame: <ModalEndGame {...modalProps} />,
        updateData: <ModalUpdateData {...modalProps} />,
      }
      const modalComponent = modalsList[modalActive.type]
        ? modalsList[modalActive.type]
        : modalsList['loading']
      setModal(modalComponent)
      sessionStorage.setItem('F_DESAFIO_GAME_MODAL_IS_OPEN', true)
    }
    return () => {
      sessionStorage.setItem('F_DESAFIO_GAME_MODAL_IS_OPEN', false)
      setModal(null)
    }
  }, [modalActive])

  return (
    modal && (
      <GenericModal
        handleClose={handleClose}
        noClose={noClose}
        colorBlur={colorBlur}>
        {modal}
      </GenericModal>
    )
  )
}
